import { render, staticRenderFns } from "./ManufacturingLogbookCountStats.vue?vue&type=template&id=23cca479"
import script from "./ManufacturingLogbookCountStats.vue?vue&type=script&lang=js"
export * from "./ManufacturingLogbookCountStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports